import React, { useEffect, useState, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './HeroMap.css';
import recenterIcon from '../assets/recenter-icon.png';
import markerIcon from '../assets/default-marker.png';
import hatImage from '../assets/hat-icon.png';
import searchIcon from '../assets/search-icon.png';
import axios from 'axios';
import './hero17.css'

const defaultIcon = L.icon({
  iconUrl: markerIcon,
  iconSize: [40, 40],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const hatIcon = L.icon({
  iconUrl: hatImage,
  iconSize: [40, 40],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = defaultIcon; // ✅ Set globally

const HeroMap = () => {
  const mapRef = useRef(null);
  const [marker, setMarker] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [fieldMarkers, setFieldMarkers] = useState([]);  // ✅ Dummy fields

  useEffect(() => {
    mapRef.current = L.map('map', {
      center: [19.0760, 72.8777],
      zoom: 12,
      zoomControl: false,         // ❌ Removed zoom controls
      attributionControl: false,   // ✅ Attribution enabled
      dragging: true,             // ✅ Pan enabled
      scrollWheelZoom: true,      // ✅ Scroll zoom enabled
      doubleClickZoom: true,      // ✅ Double-click zoom enabled
      boxZoom: true,              // ✅ Box zoom enabled
      keyboard: true              // ✅ Keyboard zoom enabled
    });

    L.tileLayer(`https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`, {
      attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a> contributors',
    }).addTo(mapRef.current);

    const userMarker = L.marker([19.0760, 72.8777])
      .addTo(mapRef.current)
      .bindPopup("<b>KaamSaathi App Map!</b><br>Explore your purpose.")
      .openPopup();

    setMarker(userMarker);

    return () => {
      mapRef.current.remove();
    };
  }, []);

  const handleRecenter = async () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }
  
    try {
      const permission = await navigator.permissions.query({ name: "geolocation" });
  
      if (permission.state === "denied") {
        alert("Location permission denied. Please enable it from settings.");
        return;
      }
  
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
  
          mapRef.current.setView([latitude, longitude], 13);
  
          if (marker) {
            marker.setLatLng([latitude, longitude])
              .bindPopup("<b>You are here!</b>")
              .openPopup();
          }
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Unable to access your location. Please enable location services.");
        },
        { 
          enableHighAccuracy: true, 
          timeout: 10000,       // ✅ Timeout added
          maximumAge: 0 
        }
      );
    } catch (error) {
      console.error("Permission error:", error);
      alert("Location permission error.");
    }
  };
  

  const handleSearch = async () => {
    if (searchQuery.trim() === '') return;

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${searchQuery}`
      );

      if (response.data.length > 0) {
        const { lat, lon } = response.data[0];

        mapRef.current.setView([lat, lon], 13);

        if (marker) {
          marker.setLatLng([lat, lon])
            .bindPopup(`<b>${searchQuery}</b>`)
            .openPopup();
        }

        addDummyFields(parseFloat(lat), parseFloat(lon));
      } else {
        alert('Location not found. Try another search.');
      }
    } catch (error) {
      console.error('Error searching location:', error);
    }
  };

  const addDummyFields = (lat, lon) => {
    if (!mapRef.current) return;

    fieldMarkers.forEach((marker) => mapRef.current.removeLayer(marker));

    const newMarkers = [];

    for (let i = 0; i < 5; i++) {
      const range = 0.065 + Math.random() * 0.005;
      const randomLat = lat + (Math.random() * range - range / 2);
      const randomLon = lon + (Math.random() * range - range / 2);

      const statuses = ['Plumber', 'Carpenter', 'Painter', 'Mechanic', 'Electrician'];
      const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];

      const fieldMarker = L.marker([randomLat, randomLon], { icon: hatIcon })
        .bindPopup(`<b>${randomStatus}</b>`)
        .addTo(mapRef.current);

      
      newMarkers.push(fieldMarker);
    }

    setFieldMarkers(newMarkers);
  };

  return (
    <>

    <div className="hero-map-container">
      <div className="map-controls">
        <input
          type="text"
          placeholder="Search for a location..."
          className="map-search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button onClick={handleSearch}>
          <img src={searchIcon} alt="Search" className="search-btn" />
        </button>

        <button onClick={handleRecenter}>
          <img src={recenterIcon} alt="Recenter" className="recenter-btn" />
        </button>
      </div>
      <div id="map" className="map"></div>
    </div>
    </>
  );
};

export default HeroMap;
